import { getDeviceType } from "./getDeviceType"

export const getFilenameForAudio = (
  name,
  state,
  activeTutorial,
  activeTrial,
  currentQuestion,
  modalOptions: null | string = null,
  options: string | undefined = undefined,
  gender: string | undefined = undefined,
  swipeTutorialFirstTime: boolean | undefined = undefined,
  isFinalScreen: boolean | undefined = undefined,
  isFinalWithPrevAnswerScreen: boolean | undefined = undefined
) => {
  let convertedId = ""
  let moveAndMoveBisTest = Array<string>()
  const device = getDeviceType() === "desktop" ? "web" : "mobile"
  const isDesktop = getDeviceType() === "desktop"

  if (currentQuestion && name !== "Swipe") {
    const item = currentQuestion.value?.item
    const proposals = currentQuestion.value?.proposals || []

    if ((name === "Move" || name === "MoveBis") && item) {
      moveAndMoveBisTest = [
        `${item}.mp3`,
        ...proposals.map((proposal) => `${proposal.proposal}.mp3`),
      ]
    } else {
      convertedId = String(currentQuestion.value?.item_id).padStart(2, "0")
    }
  }

  // Fonctions spécifiques pour gérer les états complexes
  function handleTutorialState(activeTutorial, isDesktop) {
    const tutorials = {
      0:
        isDesktop && swipeTutorialFirstTime
          ? [
              "swipe.rules.title.mp3",
              "swipe.rules.subtitle_1.mp3",
              "swipe.rules.rule_1_web.mp3",
            ]
          : isDesktop
            ? ["swipe.rules.rule_1_web.mp3"]
            : swipeTutorialFirstTime
              ? [
                  "swipe.rules.title.mp3",
                  "swipe.rules.subtitle_1.mp3",
                  "swipe.rules.rule_1_mobile.mp3",
                ]
              : ["swipe.rules.rule_1_mobile.mp3"],
      1: isDesktop
        ? ["swipe.rules.rule_2_web.mp3"]
        : ["swipe.rules.rule_2_mobile.mp3"],
      2: ["swipe.rules.rule_3.mp3"],
    }
    return tutorials[activeTutorial] || []
  }

  function handleTrialState(activeTrial, isDesktop, userGender) {
    const trials = {
      0: isDesktop
        ? [
            "swipe.tutorial.one.mp3",
            `swipe.tutorial.one_task_web_${userGender}.mp3`,
            `swipe.tutorial.one_description_web_${userGender}.mp3`,
          ]
        : [
            "swipe.tutorial.one.mp3",
            "swipe.tutorial.one_task_mobile.mp3",
            `swipe.tutorial.one_description_mobile_${userGender}.mp3`,
          ],
      1: isDesktop
        ? [
            "swipe.tutorial.two.mp3",
            `swipe.tutorial.two_task_web_${userGender}.mp3`,
            `swipe.tutorial.two_description_web_${userGender}.mp3`,
          ]
        : [
            "swipe.tutorial.two.mp3",
            "swipe.tutorial.two_task_mobile.mp3",
            `swipe.tutorial.two_description_mobile_${userGender}.mp3`,
          ],
      2: isDesktop
        ? [
            "swipe.tutorial.three.mp3",
            `swipe.tutorial.three_task.mp3`,
            `swipe.tutorial.three_description_web.mp3`,
          ]
        : [
            "swipe.tutorial.three.mp3",
            "swipe.tutorial.three_task.mp3",
            `swipe.tutorial.three_description_mobile.mp3`,
          ],
      3: [
        "swipe.tutorial.success.title.mp3",
        `swipe.tutorial.success.body.mp3`,
      ],
    }

    return trials[activeTrial] || []
  }

  function handleTestState(currentQuestion, userGender) {
    const questNum = currentQuestion + 1
    const questStr = questNum.toString().padStart(2, "0")

    if (isFinalScreen) {
      return [
        "swipe.final.title.mp3",
        "swipe.final.subtitle.mp3",
        "swipe.final.body.mp3",
      ]
    }

    if (isFinalWithPrevAnswerScreen) {
      return ["swipe.final.previous.title.mp3", "swipe.final.previous.body.mp3"]
    }

    return [
      `swipe.cards.v1.pair_${questStr}.a_${userGender}.mp3`,
      `swipe.cards.v1.pair_${questStr}.b_${userGender}.mp3`,
    ]
  }

  if (name === "Swipe") {
    const audioFiles = {
      options: {
        WELL_DONE: ["swipe.tutorial.correct.mp3"],
        TRY_AGAIN: ["swipe.tutorial.incorrect.mp3"],
        FINAL: [
          "swipe.final.title.mp3",
          "swipe.final.subtitle.mp3",
          "swipe.final.body.mp3",
        ],
        FINAL_WITH_PREV_ANSWER: [
          "swipe.final.previous.title.mp3",
          "swipe.final.previous.body.mp3",
        ],
        break: [
          "swipe.assessment.idle.title.mp3",
          "swipe.assessment.idle.body.mp3",
        ],
        restartNow: [
          "swipe.assessment.redo.now.title.mp3",
          "swipe.assessment.redo.now.body.mp3",
        ],
        restartLater: [
          "swipe.assessment.redo.later.title.mp3",
          "swipe.assessment.redo.later.body.mp3",
        ],
      },
      state: {
        intro: [
          "swipe.landing.body_1.mp3",
          "swipe.landing.body_2.mp3",
          "swipe.landing.body_3.mp3",
        ],
        welcomeBack: ["swipe.landing.welcome_back.mp3"],
        tuto: (activeTutorial, isDesktop) =>
          handleTutorialState(activeTutorial, isDesktop),
        trial: (activeTrial, isDesktop, userGender) =>
          handleTrialState(activeTrial, isDesktop, userGender),
        test: (currentQuestion, userGender) =>
          handleTestState(currentQuestion, userGender),
        nativeLanguage: ["swipe.check.title.language.mp3"],
        wholesomeConditions: (userGender) => [
          `swipe.check.title.condition_${userGender}.mp3`,
        ],
        restart: [
          "swipe.check.restart.title.mp3",
          "swipe.check.restart.body.mp3",
        ],
      },
    }

    if (modalOptions && audioFiles.options[modalOptions]) {
      return audioFiles.options[modalOptions]
    }

    const stateHandler = audioFiles.state[state]
    if (typeof stateHandler === "function") {
      if (state == "tuto") {
        return stateHandler(activeTutorial, isDesktop, gender)
      } else if (state == "trial") {
        return stateHandler(activeTrial, isDesktop, gender)
      } else if (state == "test") {
        return stateHandler(currentQuestion, gender)
      } else {
        return stateHandler(gender)
      }
    }
    return stateHandler || []
  }

  if (name === "Drive") {
    if (modalOptions === "break") {
      return [
        "drive.assessment.idle.title.mp3",
        "drive.assessment.idle.body.mp3",
      ]
    } else if (modalOptions === "restartNow") {
      return [
        "drive.assessment.redo.now.title.mp3",
        "drive.assessment.redo.now.body.mp3",
      ]
    } else if (modalOptions === "restartLater") {
      return [
        "drive.assessment.redo.later.title.mp3",
        "drive.assessment.redo.later.body.mp3",
      ]
    }

    switch (state) {
      case "intro":
        return [
          "drive.landing.body_1.mp3",
          "drive.landing.body_2.mp3",
          "drive.landing.body_3.mp3",
        ]
      case "welcomeBack":
        return ["drive.landing.body_1.mp3", "drive.landing.body_2.mp3"]

      case "rules":
        return [
          "drive.rules.title.mp3",
          "drive.rules.rule_1.mp3",
          "drive.rules.rule_2.mp3",
          "drive.rules.rule_3.mp3",
          "drive.rules.rule_4.mp3",
          "drive.rules.rule_5.mp3",
        ]

      case "practice":
        return [
          "drive.tutorial.practice.title.mp3",
          "drive.tutorial.practice.body.mp3",
        ]

      case "tuto":
        return [
          "drive.tutorial.title.mp3",
          "drive.tutorial.instruction.mp3",
          "drive.tutorial.statement_example.mp3",
          "drive.tutorial.option_1.mp3",
          "drive.tutorial.option_2.mp3",
        ]

      case "tutoEnd":
        return [
          "drive.tutorial.success.title.mp3",
          "drive.tutorial.success.body.mp3",
          "drive.tutorial.success.redo.mp3",
          "drive.tutorial.success.start.mp3",
        ]

      case "test":
        return [
          `drive.test.statement.mp3`,
          `drive.test.item_${convertedId}.a.mp3`,
          `drive.test.item_${convertedId}.b.mp3`,
        ]

      case "nativeLanguage":
        return [
          "drive.end.title.mp3",
          "drive.end.body.mp3",
          "drive.end.check.q1.mp3",
          "drive.end.check.language.mp3",
        ]

      case "wholesomeConditions":
        return ["drive.end.check.q2.mp3", "drive.end.check.condition.mp3"]

      case "restart":
        return ["drive.end.check.q3.mp3", "drive.end.check.restart.mp3"]

      default:
        console.error("Unhandled state:", state)
        return []
    }
  }

  if (name === "Brain") {
    if (modalOptions === "break") {
      return [
        "brain.assessment.idle.title.mp3",
        "brain.assessment.idle.body.mp3",
      ]
    } else if (modalOptions === "restartNow") {
      return [
        "brain.assessment.redo.now.title.mp3",
        "brain.assessment.redo.now.body.mp3",
      ]
    } else if (modalOptions === "restartLater") {
      return [
        "brain.assessment.redo.later.title.mp3",
        "brain.assessment.redo.later.body.mp3",
      ]
    }

    switch (state) {
      case "intro":
      case "welcomeBack":
        return [
          "brain.landing.body_1.mp3",
          "brain.landing.body_2.mp3",
          "brain.landing.body_3.mp3",
        ]

      case "rules":
        return [
          "brain.rules.title.mp3",
          "brain.rules.rule_1.mp3",
          "brain.rules.rule_2.mp3",
          "brain.rules.rule_3.mp3",
          "brain.rules.rule_4.mp3",
        ]

      case "resume":
        return [
          `general.assessment.resume.title_${gender}.mp3`,
          "general.assessment.resume.body.mp3",
          "brain.tutorial.checklist.item_1.mp3",
          "brain.tutorial.checklist.item_2.mp3",
          "brain.tutorial.checklist.item_3.mp3",
          "brain.tutorial.checklist.item_4.mp3",
        ]

      case "practice":
        return [
          "brain.tutorial.intro.title.mp3",
          `brain.tutorial.intro.body_${options}.mp3`,
        ]

      case "tuto":
      case "breath":
      case "test":
      case "loadResults":
      case "final":
        return []

      case "tutoConfirmation":
        return [
          "brain.tutorial.checklist.title.mp3",
          "brain.tutorial.checklist.body.mp3",
          "brain.tutorial.checklist.item_1.mp3",
          "brain.tutorial.checklist.item_2.mp3",
          "brain.tutorial.checklist.item_3.mp3",
          "brain.tutorial.checklist.item_4.mp3",
        ]

      case "tutoEnd":
        return ["brain.tutorial.end.title.mp3", "brain.tutorial.end.body.mp3"]

      case "nativeLanguage":
        return [
          "brain.end.title.mp3",
          "brain.end.body.mp3",
          "brain.end.check.q1.mp3",
          "brain.end.check.language.mp3",
        ]

      case "wholesomeConditions":
        return ["brain.end.check.q2.mp3", "brain.end.check.condition.mp3"]

      case "restart":
        return [
          "brain.assessment.redo.title.mp3",
          "brain.assessment.redo.body.mp3",
        ]

      default:
        console.error("Unhandled state:", state)
        return []
    }
  }

  if (name === "Voice") {
    // if (modalOptions === "break") {
    //   return [
    //     "brain.assessment.idle.title.mp3",
    //     "brain.assessment.idle.body.mp3",
    //   ]
    // }

    switch (state) {
      case "intro":
        return [
          "voice.landing.body_1.mp3",
          "voice.landing.body_2.mp3",
          "voice.landing.body_3.mp3",
        ]

      case "welcomeBack":
        return ["voice.landing.body_1.mp3"]

      case "rules":
        return [
          "voice.rules.title.mp3",
          "voice.rules.rule_1.mp3",
          "voice.rules.rule_2.mp3",
          "voice.rules.rule_3.mp3",
        ]

      // case "authorize":
      //   return [
      //     "voice.microphone.permission.title.mp3",
      //     "voice.microphone.permission.body.mp3",
      //   ]

      case "authorizeRefused":
        return [
          `voice.microphone.denied.title.mp3`,
          `voice.microphone.denied.body_1_${device}.mp3`,
          `voice.microphone.denied.body_2_${device}.mp3`,
          `voice.microphone.denied.body_3_${device}.mp3`,
          `voice.microphone.denied.body_4_${device}.mp3`,
          `voice.microphone.denied.body_5.mp3`,
        ]

      case "tuto":
      case "test":
      case "loadResults":
        return []

      case "end":
        return [
          "voice.end.title.mp3",
          "voice.end.body_1.mp3",
          "voice.end.body_2.mp3",
        ]

      default:
        console.error("Unhandled state:", state)
        return []
    }
  }

  if (name === "Move") {
    if (modalOptions === "break") {
      return ["move.assessment.idle.title.mp3", "move.assessment.idle.body.mp3"]
    } else if (modalOptions === "restartNow") {
      return [
        "move.assessment.redo.now.title.mp3",
        "move.assessment.redo.now.body.mp3",
      ]
    } else if (modalOptions === "restartLater") {
      return [
        "move.assessment.redo.later.title.mp3",
        "move.assessment.redo.later.body.mp3",
      ]
    }

    switch (state) {
      case "intro":
        return [
          "move.landing.body_1.mp3",
          "move.landing.body_2.mp3",
          "move.landing.body_3.mp3",
        ]
      case "welcomeBack":
        return ["move.landing.body_1.mp3", "move.landing.body_2.mp3"]

      case "rules":
        return [
          "move.rules.title.mp3",
          "move.rules.rule_1.mp3",
          "move.rules.rule_2.mp3",
          "move.rules.rule_3.mp3",
          "move.rules.rule_4.mp3",
          "move.rules.rule_5.mp3",
        ]

      case "practice":
        return [
          "move.tutorial.practice.title.mp3",
          "move.tutorial.practice.body.mp3",
        ]

      case "tuto":
        return [
          "move.tutorial.title.mp3",
          "move.tutorial.instruction.mp3",
          "move.tutorial.statement_example.mp3",
          "move.tutorial.option_1.mp3",
          "move.tutorial.option_2.mp3",
          "move.tutorial.option_3.mp3",
          "move.tutorial.option_4.mp3",
        ]

      case "tutoEnd":
        return [
          "move.tutorial.success.title.mp3",
          "move.tutorial.success.body.mp3",
        ]

      case "test":
        return moveAndMoveBisTest

      case "nativeLanguage":
        return [
          "move.end.title.mp3",
          "move.end.body.mp3",
          "move.end.check.q1.mp3",
          "move.end.check.language.mp3",
        ]

      case "wholesomeConditions":
        return ["move.end.check.q2.mp3", "move.end.check.condition.mp3"]

      case "restart":
        return ["move.end.check.q3.mp3", "move.end.check.restart.mp3"]

      default:
        console.error("Unhandled state:", state)
        return []
    }
  }

  if (name === "MoveBis") {
    if (modalOptions === "break") {
      return [
        "movebis.assessment.idle.title.mp3",
        "movebis.assessment.idle.body.mp3",
      ]
    } else if (modalOptions === "restartNow") {
      return [
        "movebis.assessment.redo.now.title.mp3",
        "movebis.assessment.redo.now.body.mp3",
      ]
    } else if (modalOptions === "restartLater") {
      return [
        "movebis.assessment.redo.later.title.mp3",
        "movebis.assessment.redo.later.body.mp3",
      ]
    }

    switch (state) {
      case "intro":
        return [
          "movebis.landing.body_1.mp3",
          "movebis.landing.body_2.mp3",
          "movebis.landing.body_3.mp3",
        ]
      case "welcomeBack":
        return ["movebis.landing.body_1.mp3", "movebis.landing.body_2.mp3"]

      case "rules":
        return [
          "movebis.rules.title.mp3",
          "movebis.rules.rule_1.mp3",
          "movebis.rules.rule_2.mp3",
          "movebis.rules.rule_3.mp3",
          "movebis.rules.rule_4.mp3",
          "movebis.rules.rule_5.mp3",
        ]

      case "practice":
        return [
          "movebis.tutorial.practice.title.mp3",
          "movebis.tutorial.practice.body.mp3",
        ]

      case "tuto":
        return [
          "movebis.tutorial.title.mp3",
          "movebis.tutorial.instruction.mp3",
          "movebis.tutorial.statement_example.mp3",
          "movebis.tutorial.option_1.mp3",
          "movebis.tutorial.option_2.mp3",
          "movebis.tutorial.option_3.mp3",
          "movebis.tutorial.option_4.mp3",
        ]

      case "tutoEnd":
        return [
          "movebis.tutorial.success.title.mp3",
          "movebis.tutorial.success.body.mp3",
          "movebis.tutorial.success.redo.mp3",
          "movebis.tutorial.success.start.mp3",
        ]

      case "test":
        return moveAndMoveBisTest

      case "nativeLanguage":
        return [
          "movebis.end.title.mp3",
          "movebis.end.body.mp3",
          "movebis.end.check.q1.mp3",
          "movebis.end.check.language.mp3",
        ]

      case "wholesomeConditions":
        return ["movebis.end.check.q2.mp3", "movebis.end.check.condition.mp3"]

      case "restart":
        return ["movebis.end.check.q3.mp3", "movebis.end.check.restart.mp3"]

      default:
        console.error("Unhandled state:", state)
        return []
    }
  }
}
